
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from '../config';

export const useProcessCaseMutation = ({setsnackbarStatus }) => {

    const queryClient = useQueryClient();

    return useMutation({

        mutationFn: ({ updaterData, route }) => {


            return axios.post(
                `${config.API_URL}/payment/${route}`,
                updaterData,
                {
                    withCredentials: true

                }

            );
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ['PaymentListPatients'], refetchType: 'active'}, {cancelRefetch: false });
            queryClient.invalidateQueries({ queryKey: ['ActivePaymentList'] , refetchType: 'active'}, {cancelRefetch: false});




            setsnackbarStatus(
                {
                    open: true,
                    message: `Upload to /${variables?.route} Successful`,
                    severity: 'success'
                }
            )

        },
        onError: (error, variables, context) => {
            console.log(error);


            if (error?.response?.status === 406) {
                setsnackbarStatus(
                    {
                        open: true,
                        message: `Payment List Already Active`,
                        severity: 'error'
                    }
                )
            } else {
                setsnackbarStatus(
                    {
                        open: true,
                        message: `Upload to /${variables?.route} Failed`,
                        severity: 'error'
                    }
                )
            }
        }
    })




}